import {Component, Input, ChangeDetectionStrategy} from "@angular/core";

@Component({
  selector: 'gen-filter-input',
  templateUrl: './filter-input.component.html',
  styleUrls: ['filter-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class FilterInputComponent {
  @Input() filter;
}
